import { useEffect, useState } from 'react'
import {useNavigate} from "react-router-dom";

const HOST_TOKEN_TIMEOUT_MS = 1500
const HOST_TOKEN_INTERVAL_MS = 100

export function setBridgeAvailable(value: boolean | null) {
    localStorage.setItem("bridgeAvailable", value == null ? 'null' : String(value))
}

export function isBridgeAvailable(): boolean | null {
    let value = localStorage.getItem("bridgeAvailable");
    return  value === 'true' ? true : value === 'false' ? false : null;
}

type Status = 'checking' | 'authenticated' | 'unavailable'

export function useBookmapAuth() {
    const [status, setStatus] = useState<Status>('checking')
    const navigate = useNavigate();

    useEffect(() => {
        if (isBridgeAvailable() === false) {
            setStatus('unavailable')
            return () => {}
        }
        let cancelled = false

        waitForHostToken(() => cancelled).then((initial) => {
            if (cancelled) return
            setBridgeAvailable(!!initial)
            setStatus(initial ? 'authenticated' : 'unavailable')
        })

        return () => {
            cancelled = true
        }
    }, [navigate])

    return { status }
}


export const waitForHostToken = async (
    shouldCancel: () => boolean
): Promise<string | null> => {
    const deadline = Date.now() + HOST_TOKEN_TIMEOUT_MS
    while (!shouldCancel()) {
        try {
            const token = await window.getUserToken?.()
            if (token) return token
        } catch (e) {
            // Host bridge is not ready yet
        }
        if (Date.now() >= deadline) return null
        await new Promise((resolve) => setTimeout(resolve, HOST_TOKEN_INTERVAL_MS))
    }
    return null
}

export const getHostToken = async (): Promise<string | null> => {
    try {
        const token = await window.getUserToken?.()
        return token ?? null
    } catch {
        return null
    }
}

export async function getBookmapAuthHeaders(): Promise<Record<string, string>> {
    if (isBridgeAvailable() === false) return {}

    let token = await getHostToken()
    if (!token) {
        token = await waitForHostToken(() => false)
    }
    return token ? { 'X-Web-Bookmap-Token': token } : {}
}

